import {
  useCallback,
  MutableRefObject,
  useState,
  ChangeEvent,
  useEffect,
  useRef,
} from "react";
import { SessoesInstancia } from "modulos/cardapio/componentes/produtos";
import { isEmpty } from "lodash";
import { useInView } from "react-intersection-observer";
import { useObterSacola } from "storage";
import { useHistory } from "react-router-dom";
import { useNotificacoes } from "components";
import { ProdutoModel } from "api/cardapio/models/produto/produto-model";
import { ProdutoCategoriaModel } from "api/cardapio/models/produto/produto-categoria-model";
import { MovSimplesProdutoModel } from "api/cardapio/models/produto/mov-simples-produto-model";
import { CardapioDadosProps } from "../cardapio-header/cardapio-header-props";
import { lojaAberta } from "utils";
import { useSacolaAbertaStore } from "services/store/sacola-aberta";
import { useFuncoesNavbarStore } from "services/store/funcoes-navbar";
import { useObterToken } from "services/store/obter-token";
import { usePessoaUsuarioStore } from "services/store/pessoa-usuario";
import { useDadosDeliveryStore } from "services/store/dados-delivery";

export enum EnumTipoScanner {
  VisualizarPedido,
  PrepararPedido,
}

export interface CardapioLogicaProps {
  sessoes: MutableRefObject<SessoesInstancia | null>;
  pesquisa: MutableRefObject<HTMLDivElement | null>;
  menuNavRef: MutableRefObject<HTMLDivElement | null>;
  produtos: ProdutoCategoriaModel[];
  empresaId: string;
  cardapioDados: CardapioDadosProps | undefined;
}

export const useCardapioLogica = ({
  cardapioDados,
  empresaId,
  menuNavRef,
  pesquisa,
  produtos,
  sessoes,
}: CardapioLogicaProps) => {
  const history = useHistory();
  const [resultadoPesquisa, definirResultadoPesquisa] = useState<
    Array<ProdutoModel>
  >(new Array<ProdutoModel>());
  const [carregandoPesquisa, definirCarregandoPesquisa] = useState(false);
  const [categoriaSendoExibida, definirCategoriaExibida] = useState<
    string | undefined
  >(undefined);
  const [produto, setProduto] = useState<MovSimplesProdutoModel>(
    new MovSimplesProdutoModel()
  );
  const [categoriaSelecionada, definirCategoriaSelecionada] = useState<
    string | undefined
  >(undefined);
  const [formaPagModal, setFormaPagModal] = useState<boolean>(false);
  const [pagPixModal, setPagPixModal] = useState<boolean>(false);
  const [modalCliente, setModalCliente] = useState(false);
  const [dialogAutenticar, setDialogAutenticar] = useState<boolean>(false);
  const [garcom, setGarcom] = useState(false);
  const [scannerComanda, setScannerComanda] = useState(false);
  const [tipoScanner, setTipoScanner] = useState<EnumTipoScanner>(
    EnumTipoScanner.PrepararPedido
  );
  const [produtoAberto, setProdutoAberto] = useState<boolean>(false);
  const [dialogSubitem, setDialogSubItem] = useState<boolean>(false);
  const [mostrarCategoriaHeader, setMostrarCategoriaHeader] = useState<boolean>(
    false
  );
  const rolandoCategoria = useRef<any>(null);
  const { showErrorMessage, showWarningMessage } = useNotificacoes();

  const { horarioFuncionamento, empresa } = cardapioDados!;

  const itensSacola = useObterSacola(empresaId);

  const { termoPesquisa, setTermoPesquisa } = useFuncoesNavbarStore();
  const deslogar = useObterToken(state => state.deslogar)
  const { setPessoa } = usePessoaUsuarioStore()
  const { setEnderecoDelivery, setTipoDelivery } = useDadosDeliveryStore()

  const countSacola = useCallback(() => {
    if (itensSacola?.data?.length === 1 && !useSacolaAbertaStore.getState().sacolaAberta) {
      useSacolaAbertaStore.getState().abrirSacola();
    } else {
      if (itensSacola?.data?.length === 0 && !useSacolaAbertaStore.getState().sacolaAberta) {
        useSacolaAbertaStore.getState().fecharSacola();
      }
    }
  }, [itensSacola?.data?.length]);

  useEffect(() => {
    countSacola();
  }, [countSacola]);

  const validarTelefone = useCallback((valor: string) => {
    if (isEmpty(valor)) return ".";

    return `, ou entre em contato conosco pelo telefone ${valor}.`;
  }, []);

  const validarRestauranteAberto = useCallback(() => {
    let isAberto;
    if (
      horarioFuncionamento?.empresaHorarioDias === null ||
      horarioFuncionamento?.empresaHorarioDias === undefined
    )
      showErrorMessage(
        `Erro ao buscar o horário de funcionamento da loja. Detalhe: Erro de comunicação com o servidor, tente novamente em alguns instantes${validarTelefone(
          empresa?.fone!
        )}`
      );
    else if (horarioFuncionamento?.empresaHorarioDias?.length! < 1) {
      showWarningMessage("A loja está fechada.");
    } else {
      const isLojaAberta = lojaAberta(horarioFuncionamento);

      if (!isLojaAberta) {
        showWarningMessage("A loja está fechada.");
        isAberto = false;
      } else {
        isAberto = true;
      }
    }
    return isAberto;
  }, [
    empresa?.fone,
    horarioFuncionamento,
    showErrorMessage,
    showWarningMessage,
    validarTelefone,
  ]);

  const { ref: header, inView: headerEstaSendoVisualizado } = useInView({
    threshold: 0,
    initialInView: true,
  });

  const abrirAdicaoProduto = useCallback((sessao?: ProdutoCategoriaModel) => {
    definirCategoriaSelecionada(sessao?.id);
  }, []);

  const fecharEdicaoProduto = useCallback(() => {
    setProdutoAberto(false);
    definirCategoriaSelecionada(undefined);
  }, []);

  const abrirEdicaoProduto = useCallback(
    (produto: MovSimplesProdutoModel) => {
      if (validarRestauranteAberto()) {
        setProduto(produto!);
        if (produto.subItens.length === 0) {
          setProdutoAberto(true);
          return;
        }
        setDialogSubItem(true);
      }
    },
    [validarRestauranteAberto]
  );

  const quandoSessaoForExibida = useCallback(
    (sessao?: ProdutoCategoriaModel) => {
      if (rolandoCategoria.current === null)
        definirCategoriaExibida(sessao?.id);
    },
    []
  );

  const categoriaClick = useCallback(
    (categoriaId: string) => {
      sessoes.current?.rolarParaSessao(categoriaId);
      definirCategoriaExibida(categoriaId);
      // Fizemos este timeout para dar tempo de rolar a página no momento que clicar na tab para alterar a categoria,
      // pois quando clicava na categoria, ele rolava pra cima novamente para ir a outra categoria exibida.
      rolandoCategoria.current = setTimeout(() => {
        rolandoCategoria.current = null;
      }, 5000);
    },
    [sessoes]
  );

  const pesquisando = isEmpty(termoPesquisa) === false

  const buscarClick = useCallback(() => {
    if (pesquisando === false) {
      return;
    }

    const pesquisaScrollInterval = setInterval(() => {
      if (!pesquisa?.current) {
        return;
      }

      clearInterval(pesquisaScrollInterval);

      window.scrollTo({
        behavior: "smooth",
        top:
          (pesquisa?.current?.offsetTop || 0) -
          (menuNavRef?.current?.offsetHeight || 0) -
          10,
      });
    }, 50);
  }, [pesquisa, pesquisando, menuNavRef]);

  const quandoTermoForDigitadoNoNavbar = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setTermoPesquisa(event.target.value);

      setTimeout(() => {
        buscarClick();
      }, 200);
    },
    [buscarClick, setTermoPesquisa]
  );

  useEffect(() => {
    definirCarregandoPesquisa(true);

    const timeoutId = setTimeout(() => {
      const resultado = sessoes?.current?.pesquisarSessoes(termoPesquisa);

      if (resultado) {
        definirResultadoPesquisa(resultado);
      }

      definirCarregandoPesquisa(false);
    }, 400);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [termoPesquisa, sessoes, produtos]);

  const abrirScannerComanda = useCallback(() => {
    setScannerComanda(true);
  }, []);

  const fecharScannerComanda = useCallback(() => {
    setScannerComanda(false);
  }, []);

  const abrirGarcom = useCallback(() => {
    setGarcom(true);
  }, []);

  const fecharGarcom = useCallback(() => {
    setGarcom(false);
  }, []);

  const abrirModalCliente = useCallback(() => {
    setModalCliente(true);
  }, []);

  const fecharModalCliente = useCallback(() => {
    setModalCliente(false);
  }, []);

  const abrirModalFormaPag = useCallback(() => {
    setFormaPagModal(true);
  }, []);

  const fecharModalFormaPag = useCallback(() => {
    setFormaPagModal(false);
  }, []);

  const abrirModalPagPix = useCallback(() => {
    setPagPixModal(true);
  }, []);

  const fecharModalPagPix = useCallback(() => {
    setPagPixModal(false);
  }, []);

  const definirTipoScanner = useCallback((tipo: EnumTipoScanner) => {
    setTipoScanner(tipo);
  }, []);

  const navegarConfigurando = useCallback(() => {
    history.push(`/${empresaId}/configuracoes`);
  }, [empresaId, history]);

  const logar = useCallback(() => {
    history.push(`/${empresaId}`);
  }, [empresaId, history]);

  const logout = useCallback(() => {
    deslogar()
    setPessoa(undefined)
    setEnderecoDelivery(undefined)
    setTipoDelivery(undefined)
    history.push(`/${empresaId}`);
  }, [deslogar, setPessoa, setEnderecoDelivery, setTipoDelivery, history, empresaId]);

  return {
    operacoes: {
      categoriaClick,
      quandoTermoForDigitadoNoNavbar,
      quandoSessaoForExibida,
      fecharEdicaoProduto,
      abrirEdicaoProduto,
      abrirAdicaoProduto,
      abrirGarcom,
      fecharGarcom,
      configurandoWrapper: navegarConfigurando,
      logout,
      logar,
      fecharScannerComanda,
      abrirModalCliente,
      fecharModalCliente,
      abrirModalFormaPag,
      fecharModalFormaPag,
      abrirModalPagPix,
      fecharModalPagPix,
      abrirScannerComanda,
      definirTipoScanner,
      setDialogSubItem,
      setDialogAutenticar,
      setMostrarCategoriaHeader,
    },
    dados: {
      termoPesquisa,
      carregandoPesquisa,
      resultadoPesquisa,
      pesquisando,
      header,
      headerEstaSendoVisualizado,
      categoriaSendoExibida,
      produto: produto,
      produtoAberto,
      categoriaSelecionada,
      dialogAutenticar,
      garcom,
      scannerComanda,
      modalCliente,
      formaPagModal,
      pagPixModal,
      tipoScanner,
      dialogSubitem,
      mostrarCategoriaHeader,
    },
  };
};
